import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'reactstrap'
import FormItem from '../../components/form/FormItem'
import { useDispatch } from 'react-redux'
import { fetchContactGet } from '../../redux/slices/contactGetSlice'
import { fetchContactUpdate } from '../../redux/slices/contactUpdateSlice'
import { PiPhone } from 'react-icons/pi'
import { BsMailbox } from 'react-icons/bs'
import { LuMapPin } from "react-icons/lu";
import { CiLinkedin } from "react-icons/ci";
import { MdOutlineFax } from "react-icons/md";
import { IoBusinessOutline } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'
import { GrMapLocation } from "react-icons/gr";

const CrudContact = () => {
    const [formData, setFormData] = useState({ files: [], phone: "", mail: "", fax: "", instagram: "", facebook: "", linkedin: "", youtube: "" })
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const getData = async () => {
        var data = await dispatch(fetchContactGet())
        if (data.payload) {
            setFormData({
                files: data.payload?.files,
                countrytr: data.payload?.country["tr"] || "",
                countryen: data.payload?.country["en"] || "",
                citytr: data.payload?.city["tr"] || "",
                cityen: data.payload?.city["en"] || "",
                districttr: data.payload?.district["tr"] || "",
                districten: data.payload?.district["en"] || "",
                addresstr: data.payload?.address["tr"] || "",
                addressen: data.payload?.address["en"] || "",
                companytr: data.payload?.company["tr"] || "",
                companyen: data.payload?.company["en"] || "",
                companydescriptiontr: data.payload?.companyDescription["tr"] || "",
                companydescriptionen: data.payload?.companyDescription["en"] || "",
                phone: data.payload?.phone,
                mail: data.payload?.mail,
                fax: data.payload?.fax,
                instagram: data.payload?.instagram,
                facebook: data.payload?.facebook,
                linkedin: data.payload?.linkedin,
                youtube: data.payload?.youtube,
                specialField1tr: data.payload?.specialField1["tr"] || "",
                specialField1en: data.payload?.specialField1["en"] || "",
                location1: data.payload?.location["location1"] || "",
                location2: data.payload?.location["location2"] || "",
            })
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const country = { "tr": formData.countrytr, "en": formData.countryen }
        const city = { "tr": formData.citytr, "en": formData.cityen }
        const district = { "tr": formData.districttr, "en": formData.districten }
        const address = { "tr": formData.addresstr, "en": formData.addressen }
        const company = { "tr": formData.companytr, "en": formData.companyen }
        const companyDescription = { "tr": formData.companydescriptiontr, "en": formData.companydescriptionen }
        const specialField1 = { "tr": formData.specialField1tr, "en": formData.specialField1en }
        const specialField2 = {}
        const specialField3 = {}
        const specialField4 = {}
        const specialField5 = {}
        const location = { "location1": formData.location1, "location2": formData.location2 }

        await dispatch(
            fetchContactUpdate({
                file: formData.files,
                country: country,
                city: city,
                district: district,
                address: address,
                company: company,
                companyDescription: companyDescription,
                phone: formData.phone,
                mail: formData.mail,
                location: location,
                fax: formData.fax,
                instagram: formData.instagram,
                facebook: formData.facebook,
                linkedin: formData.linkedin,
                youtube: formData.youtube,
                specialField1: specialField1,
                specialField2: specialField2,
                specialField3: specialField3,
                specialField4: specialField4,
                specialField5: specialField5
            })
        )

        getData()
    }

    useEffect(() => { getData() }, [dispatch])

    return (
        <Form onSubmit={handleSubmit} className='mt-4'>
            <Row>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`phone`}
                        name={`phone`}
                        type="text"
                        icon={<PiPhone size={20} />}
                        title={`${t("phone")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='phone'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`fax`}
                        name={`fax`}
                        type="text"
                        icon={<MdOutlineFax size={20} />}
                        title={`${t("fax")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='fax'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`mail`}
                        name={`mail`}
                        type="text"
                        icon={<BsMailbox size={20} />}
                        title={`${t("mail")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='mail'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`linkedin`}
                        name={`linkedin`}
                        type="text"
                        icon={<CiLinkedin size={20} />}
                        title={`${t("linkedin")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='linkedin'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`linkedin_desctr`}
                        name={`linkedin_desctr`}
                        type="text"
                        icon={<CiLinkedin size={20} />}
                        title={`${t("linkedin_desc")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField1tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`linkedin_descen`}
                        name={`linkedin_descen`}
                        type="text"
                        icon={<CiLinkedin size={20} />}
                        title={`${t("linkedin_desc")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField1en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`companytr`}
                        name={`companytr`}
                        type="text"
                        icon={<IoBusinessOutline size={20} />}
                        title={`${t("company")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='companytr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`companyen`}
                        name={`companyen`}
                        type="text"
                        icon={<IoBusinessOutline size={20} />}
                        title={`${t("company")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='companyen'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`companydescriptiontr`}
                        name={`companydescriptiontr`}
                        type="text"
                        icon={<IoBusinessOutline size={20} />}
                        title={`${t("company_desc")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='companydescriptiontr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`companydescriptionen`}
                        name={`companydescriptionen`}
                        type="text"
                        icon={<IoBusinessOutline size={20} />}
                        title={`${t("company_desc")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='companydescriptionen'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`location1`}
                        name={`location1`}
                        type="text"
                        icon={<LuMapPin size={20} />}
                        title={`${t("location")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='location1'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`location2`}
                        name={`location2`}
                        type="text"
                        icon={<GrMapLocation size={20} />}
                        title={`${t("map")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='location2'
                    />
                </Col>
            </Row>
            <div className='d-flex justify-content-end mt-4 w-100'>
                <Button type='submit' color='warning' className="text-white">
                    {t("edit")}
                </Button>
            </div>
        </Form>
    )
}

export default CrudContact
